import NiceModal from '@ebay/nice-modal-react';

import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';

import PasswordInput from 'components/field/PasswordInput';
import StringInput from 'components/field/StringInput';
import FormItem from 'components/form/FormItem';
import Icon from 'components/global/Icon';
import Typography from 'components/global/Typography';

import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';

import * as S from './Common.styled';
import PrivacyPolicyModal from './PrivacyPolicyModal';
import SigninWithGoogle from './SigninWithGoogle';

const LinkViewer = ({ children, onClick, errors }) => {
	const { t } = useTranslation();
	return (
		<Typography
			variant="p3"
			color={errors?.aggreedTerms ? 'var(--red)' : 'var(--blue)'}
			onClick={onClick}
			style={{ textDecoration: 'underline', display: 'inline' }}
			noWrap>
			{t(children)}
		</Typography>
	);
};

const RegisterFirstStep = ({ loading }) => {
	const formMethods = useFormContext();

	const {
		watch,
		formState: { errors }
	} = formMethods;

	const watchedPassword = watch('password');

	return (
		<>
			<FormItem>
				<Typography noWrap variant="h3" fontWeight="700" gutterBottom>
					createYourFreeAccount
				</Typography>
			</FormItem>
			{import.meta.env.VITE_PLATFORM !== 'desktop' && (
				<>
					<FormItem>
						<SigninWithGoogle disabled={loading} />
					</FormItem>
					<FormItem>
						<S.Seperator>
							<Typography variant="p2">key.or</Typography>
						</S.Seperator>
					</FormItem>
				</>
			)}
			<FormItem label="emailRegister" required>
				<StringInput name="mail" placeholder="emailPlaceholder" />
			</FormItem>
			<FormItem label="password" required>
				<PasswordInput name="password" />
			</FormItem>
			{watchedPassword ? (
				<FormItem>
					<S.PasswordValidationContainer>
						<S.PasswordRequirement>
							<Icon
								icon={faCircleCheck}
								color={watchedPassword?.length >= 8 ? 'var(--blue)' : 'var(--black-20)'}
							/>
							<Typography color="var(--content-3)">passwordRequirements.8Characters</Typography>
						</S.PasswordRequirement>
						<S.PasswordRequirement>
							<Icon
								icon={faCircleCheck}
								color={watchedPassword?.match(/\d/) ? 'var(--blue)' : 'var(--black-20)'}
							/>
							<Typography color="var(--content-3)">passwordRequirements.number</Typography>
						</S.PasswordRequirement>
						<S.PasswordRequirement>
							<Icon
								icon={faCircleCheck}
								color={watchedPassword?.match(/[A-Z]/) ? 'var(--blue)' : 'var(--black-20)'}
							/>
							<Typography color="var(--content-3)">passwordRequirements.Uppercase</Typography>
						</S.PasswordRequirement>
						<S.PasswordRequirement>
							<Icon
								icon={faCircleCheck}
								color={watchedPassword?.match(/[a-z]/) ? 'var(--blue)' : 'var(--black-20)'}
							/>
							<Typography color="var(--content-3)">passwordRequirements.Lowercase</Typography>
						</S.PasswordRequirement>
					</S.PasswordValidationContainer>
				</FormItem>
			) : null}

			<FormItem>
				<S.AgreementContainer>
					<Typography noWrap variant="p3">
						<Trans
							i18nKey={`register.agreeTerms`}
							components={{
								linkViewer: (
									<LinkViewer
										errors={errors}
										onClick={
											loading
												? () => {}
												: (e) => {
														NiceModal.show(PrivacyPolicyModal);
														e.stopPropagation();
													}
										}
									/>
								),
								kvkk: (
									<LinkViewer
										errors={errors}
										onClick={
											loading
												? () => {}
												: (e) => {
														NiceModal.show(PrivacyPolicyModal, {
															textKey: 'register.policyText'
														});
														e.stopPropagation();
													}
										}
									/>
								)
							}}
						/>
					</Typography>
				</S.AgreementContainer>
			</FormItem>
		</>
	);
};

export default RegisterFirstStep;
